// extracted by mini-css-extract-plugin
export default {"centeredDescription":"section-text_centeredDescription__4jiOG","regularDescription":"section-text_regularDescription__8XRqZ"};